import { Button, CircularProgress, Drawer, Grid, Typography } from "@mui/material";
import React, { FC, useEffect, useState } from "react";
import { useCategoryStore } from "../../../hooks/useCategoryStore";
import CustomTable from "../../../components/common/CustomTable/CustomTable";

const columns = [
    { type: 'checkbox', field: 'checkbox', label: '', align: 'center' },  
    { type: 'text', field: 'name', label: 'Familia', align: 'center' },
    { type: 'text', field: 'total', label: 'Veces Repetido', align: 'center' },
];

export const DrawerDuplicated: FC<any> = (props): JSX.Element | any => {
    const { open, closeModal } = props;
    const { getCategoriesDuplicated, unifyDuplicated } = useCategoryStore();
    
    const [data, setData] = useState<any[]>([]);
    const [loading, setLoading] = useState<boolean>(false);
    const [loadingSaveReference, setLoadingSaveReference] = useState<boolean>(false);
    const [selectedRows, setSelectedRows] = useState<any[]>([]);  // Estado para filas seleccionadas

    useEffect(() => {
        getCategoriesDuplicatedAPI();
    }, []);

    const getCategoriesDuplicatedAPI = async () => {
        setLoading(true);
        try {
            const response = await getCategoriesDuplicated();
            setData(response);
        } catch (error) {
            console.error('Error fetching duplicated categories', error);
        } finally {
            setLoading(false);
        }
    };

    const addReference = async() => {
        console.log('Filas seleccionadas para unificar:', selectedRows);
        const payload = {
            dataCategory: selectedRows
        }
        await unifyDuplicated(payload);
        closeModal();
    };

    const onCheckbox = (row: any) => {
        const selectedIndex = selectedRows.findIndex(selectedRow => selectedRow.name === row.name);
        let newSelected:any = [];

        if (selectedIndex === -1) {
            newSelected = newSelected.concat(selectedRows, row);
        } else if (selectedIndex === 0) {
            newSelected = newSelected.concat(selectedRows.slice(1));
        } else if (selectedIndex === selectedRows.length - 1) {
            newSelected = newSelected.concat(selectedRows.slice(0, -1));
        } else if (selectedIndex > 0) {
            newSelected = newSelected.concat(
                selectedRows.slice(0, selectedIndex),
                selectedRows.slice(selectedIndex + 1)
            );
        }
        setSelectedRows(newSelected);
    };

    const isSelected = (row: any) => selectedRows.some(selectedRow => selectedRow.name === row.name);


    return (
        <>
            <Drawer anchor="right" open={open} onClose={closeModal} ModalProps={{ keepMounted: true }} PaperProps={{ sx: { width: 550 } }}>
                <Grid container spacing={2} padding={4}>
                    <Grid item xs={12}>
                        <Typography variant='h6' component='h1' className='title-main'>Familias duplicadas</Typography>
                    </Grid>
                    <Grid item xs={12} sx={{ display: 'flex', justifyContent: 'right' }}>
                        <Button
                            sx={{
                                backgroundColor: '#ffffff',
                                border: '1px solid #69ABC3',
                                borderRadius: '10px',
                                color: '#69ABC3',
                                height: '25px',
                                padding: '6px 16px',
                                textTransform: 'none',
                                width: 180,
                                "&:hover": { backgroundColor: "#ffffff" }
                            }}
                            onClick={addReference}
                        >
                            Unificar registros
                            {loadingSaveReference && (
                                <CircularProgress color="inherit" size={12} sx={{ color: '#5b5b5b', marginLeft: "10px" }} />
                            )}
                        </Button>
                    </Grid>

                    <Grid item xs={12}>
                        <CustomTable
                            disabled_title
                            columns={columns}
                            loading={loading}
                            rows={data}
                            onRowClick={() => { }} 
                            isSelected={isSelected} 
                            onCheckbox={onCheckbox} 
                            hasOptions={false}
                            dense
                        />
                    </Grid>
                </Grid>
            </Drawer>
        </>
    );
};
